import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import {FaWhatsapp} from 'react-icons/fa';

export const FinalCTA = () => {
  const whatsappUrl = 'https://wa.me/6281517118799?text=Hello%20Indotravelista,%20I%20would%20like%20to%20plan%20a%20bespoke%20journey.';

  return (
    <section style={{
      background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
      padding: '100px 0',
      textAlign: 'center',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Subtle pattern overlay */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        opacity: 0.03,
        backgroundImage: 'radial-gradient(circle, #ffffff 1px, transparent 1px)',
        backgroundSize: '30px 30px'
      }} />
      
      <div className="container" style={{ position: 'relative', zIndex: 1 }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <h2 style={{
            fontSize: 'clamp(32px, 4vw, 48px)',
            fontFamily: "'Crimson Text', serif",
            fontWeight: 400,
            color: '#ffffff',
            marginBottom: '24px',
            lineHeight: 1.2
          }}>
            Your Indonesia Story Starts Here
          </h2>
          <p style={{
            fontSize: '18px',
            color: 'rgba(255, 255, 255, 0.9)',
            marginBottom: '48px',
            lineHeight: 1.7,
            maxWidth: '600px',
            margin: '0 auto 48px'
          }}>
            Tell us what kind of journey you&apos;re dreaming of. We&apos;ll help you turn it into an experience worth remembering.
          </p>
          
          <div style={{
            display: 'flex',
            gap: '16px',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            <Link 
              to="/contact"
              style={{
                background: '#ffffff',
                color: '#333333',
                border: '1px solid #ffffff',
                borderRadius: 0,
                padding: '19px 32px',
                minWidth: '210px',
                height: '60px',
                fontSize: '14px',
                fontWeight: 700,
                cursor: 'pointer',
                transition: 'all 0.2s',
                textDecoration: 'none',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'transparent';
                e.target.style.color = '#ffffff';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = '#ffffff';
                e.target.style.color = '#333333';
              }}
            >
              Plan My Journey
              <ArrowRight size={16} />
            </Link>

            <a 
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                background: 'transparent',
                color: '#ffffff',
                border: '1px solid rgba(255,255,255,0.5)',
                borderRadius: 0,
                padding: '19px 32px',
                minWidth: '210px',
                height: '60px',
                fontSize: '14px',
                fontWeight: 700,
                cursor: 'pointer',
                transition: 'all 0.2s',
                textDecoration: 'none',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
              }}
              onMouseEnter={(e) => {
                e.target.style.borderColor = '#ffffff';
                e.target.style.background = 'rgba(255,255,255,0.1)';
              }}
              onMouseLeave={(e) => {
                e.target.style.borderColor = 'rgba(255,255,255,0.5)';
                e.target.style.background = 'transparent';
              }}
            >
            <FaWhatsapp size={16} />
              WhatsApp Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
